import { ButtonHTMLAttributes } from 'react';
import styles from './LinkButton.module.scss';
import { Icon, IconProp } from '../Icon/Icon';
import type { ButtonSize } from '../Button/Button';
import useClasses from '../../utility/useClasses';

export interface LinkButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    size?: ButtonSize;
    icon?: IconProp;
    iconPosition?: 'left' | 'right';
    underline?: boolean;
}

function Button({
        size = 'sm',
        icon,
        iconPosition = 'left',
        title,
        underline,
        ...props
    }: LinkButtonProps
) {

    const classes = useClasses(styles, {
        button: true,
        [size]: true,
        underline: underline,
        "flex-row": iconPosition === "left",
        "flex-row-reverse": iconPosition === "right",
    });

    return (
        <button {...props} className={classes}>
            {icon &&
                <Icon icon={icon} />
            }
            {title &&
                <span>{title}</span>
            }
        </button>
    );
}
export default Button;
